import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { WirelessAlertsModel } from 'src/Models/TrfaAlertsModel';
import { TrfaAlertService } from 'src/Services/alert.service';
import { CheckAuth } from 'src/Services/utility.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-manage-wireless-alerts',
  templateUrl: './manage-wireless-alerts.component.html',
  styleUrls: ['./manage-wireless-alerts.component.css']
})
export class ManageWirelessAlertsComponent implements OnInit {

  tokenKey: string = '';
  userId: number = 0;
  SelectedTool: string;
  productId: number = 1;
  multiSelectDropDownHeight: number = 200;


  WirelessAlertsModel = new WirelessAlertsModel()

  addUpdateWirelessAlert = new FormGroup({
    updateId: new FormControl(''),
    updateDate: new FormControl(''),
    description: new FormControl(''),
    isNotify: new FormControl(0),
  });

  isWirelessAlerts: boolean = true;
  updateId: number = 0;
  isDataLoad: boolean = false;
  isViewMode: boolean = false;

  isNotify: boolean = true;

  pageNumber:number;
  pageSize:number;
  Email:string = '';
  Name:string = '';
  orderBy:string;
  updateCategoryName:string;
  
  constructor(private readonly activedRoute: ActivatedRoute, 
    private readonly checkAuth: CheckAuth, 
    private readonly trfaAlertServices:TrfaAlertService,
    private readonly toastr: ToastrService, 
    private readonly router: Router,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService
  ) {
      this.tokenKey = this.sessionStorageService.getTokenValue();
      this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
      this.SelectedTool = this.sessionStorageService.getUserLoginTool();
      this.productId = ToolEnum.wireless;
      this.titleService.setTitle('Manage wireless Alert');
    }
    ngOnInit() {
      this.pageNumber = 1;
      this.pageSize = 10;
      this.orderBy = 'updateId ASC'
      this.activedRoute.params.subscribe((params: Params) => {
  
        if (params['id']) {
          if (params['id'] != null) {
            this.isWirelessAlerts = false;
            this.updateId = params['id'];
            this.userId = params['userid'];
            this.GetWirelessAlertsByUser();
          }
        }
        else {
          this.userId = 0;
        }
      });
    }
    tokenExpireCalculation(startDate: string, tokenExpiry: string) {
      this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
    }
    
    GetWirelessAlertsByUser(): void {
      this.isDataLoad = true;
      this.trfaAlertServices.GetWirelessAlertsByUser(this.tokenKey, this.updateId,this.pageNumber,this.pageSize,this.userId,this.orderBy,this.productId).subscribe(
        data => {
          if (data["voipAlertuser"] != null && data["status"] != "Failure") {
  
            this.WirelessAlertsModel = data['voipAlertuser'][0];
  
            this.Email=this.WirelessAlertsModel.email;
            this.Name=this.WirelessAlertsModel.name;
            this.updateCategoryName=this.WirelessAlertsModel.updateCategoryName;
  
            if (this.WirelessAlertsModel != null) {
              const updateDate = new Date(this.WirelessAlertsModel.updateDate);
            
              let dd1 = updateDate.getDate().toString();
              if (parseInt(dd1) < 10) {
                dd1 = '0' + dd1;
              }
            
              let mm1 = (updateDate.getMonth() + 1).toString();
              if (parseInt(mm1) < 10) {
                mm1 = '0' + mm1;
              }
            
              this.WirelessAlertsModel.updateDate = `${mm1}/${dd1}/${updateDate.getFullYear()}`;
            }
  
            this.addUpdateWirelessAlert.setValue({
              updateId: this.WirelessAlertsModel.updateId,
              updateDate: this.WirelessAlertsModel.updateDate,
              //note: this.VoipAlertsModel.note,
              description: this.WirelessAlertsModel.description,
              isNotify: this.WirelessAlertsModel.isSendMail
            });
  
            this.isDataLoad = false;
          }
          else {
            this.isDataLoad = false;
            this.showMessage(data["message"], 'Error', 'error');
          }
        }, error => {
          this.isDataLoad = false;
          this.showMessage(error, 'Error', 'error');
        })
  
    }
  
  
    showMessage(msg: string, msgTitle: string, msgType: string) {
      if (msgType == 'success') {
        setTimeout(() => this.toastr.success(msg, msgTitle));
      }
      else if (msgType == 'error') {
        setTimeout(() => this.toastr.error(msg, msgTitle));
      }
    }
  
    isAlertDate(dateArray: any) {
      if (dateArray != null) {
        let dd1 = dateArray.getDate().toString();
        if (parseInt(dd1.toString()) < 10)
          dd1 = '0' + dd1.toString();
  
        let mm1 = (dateArray.getMonth() + 1).toString();
        if (parseInt(mm1.toString()) < 10)
          mm1 = '0' + mm1.toString();
  
        this.WirelessAlertsModel.updateDate = mm1 + '/' + dd1 + '/' + dateArray.getFullYear();
      }
      else
        this.WirelessAlertsModel.updateDate = null;
    }
  
    saveAddUpdateWirelessAlert(addUpdateWirelessAlert: any) {
      if (addUpdateWirelessAlert.value['updateDate'] == '') {
        this.showMessage('Please select alert date', 'Error', 'error');
        return;
      }
      let currentDate = new Date();
      if (new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) > addUpdateWirelessAlert.value["updateDate"]) {
        this.showMessage('Previous alert date not allow', 'Error', 'error');
        return;
      }
  
      if (addUpdateWirelessAlert.value['description'] == '' || typeof (addUpdateWirelessAlert.value['description']) == 'undefined') {
        this.showMessage('Please enter description', 'Error', 'error');
        return;
      }
      if (addUpdateWirelessAlert.value['description'] != '') {
        if (addUpdateWirelessAlert.value['description'].toString().trim() == '') {
          this.showMessage('Please enter description', 'Error', 'error');
          return;
        }
      }
  
      if (typeof (addUpdateWirelessAlert.value['updateId']) == 'undefined') {
        this.WirelessAlertsModel.updateId = 0;
      }
      else {
        this.WirelessAlertsModel.updateId = addUpdateWirelessAlert.value['updateId'];
      }
  
      if (typeof (addUpdateWirelessAlert.value['description']) == 'undefined') {
        this.WirelessAlertsModel.description = '';
      }
      else {
        this.WirelessAlertsModel.description = addUpdateWirelessAlert.value['description'];
      }
      this.WirelessAlertsModel.isSendMail = this.isNotify;
      this.WirelessAlertsModel.userId = this.userId;
      this.WirelessAlertsModel.updateDate=addUpdateWirelessAlert.value['updateDate'];
      this.WirelessAlertsModel.productId=this.productId;
     
      this.trfaAlertServices.AddUpdateVoipAlerts(this.tokenKey, this.WirelessAlertsModel).subscribe(
        data => {
          if (data['status'] == 'Success') {
            this.showMessage('Wireless alerts Updated successfully', 'Success', 'success');
            this.router.navigate(['/admin/Wireless/Wireless-Alerts']);
          }
          else
            this.showMessage(data['status'], 'Error', 'error');
        },
        error => {
          this.showMessage(error, 'Error', 'error');
        }
      );
    }
    
    removeHTMLTags(str) {
      if ((str === null) || (str === ''))
        return false;
      else
        str = str.toString();
      return str.replace(/<[^>]*>/g, '');
    }
  
    setSendEmailNotificationChecked($event) {
      this.isNotify = $event.target.checked;
    }

}
